'use client';
import React from 'react';
import AppImage from '@/components/ui/AppImage';
import { Download, Share2 } from 'lucide-react';
import { toast } from 'sonner';

const PORTRAITS = [
{ id: 'port-001', src: "https://img.rocket.new/generatedImages/rocket_gen_img_1719945c6-1772135486894.png", alt: 'Artistic portrait of golden retriever Biscuit in oil painting style with warm autumn colors', style: 'Oil Painting', date: 'Jun 5, 2026' },
{ id: 'port-002', src: "https://img.rocket.new/generatedImages/rocket_gen_img_12e134b2c-1772209372270.png", alt: 'Watercolor portrait of golden retriever with soft pastel background and floral elements', style: 'Watercolor', date: 'May 20, 2026' },
{ id: 'port-003', src: "https://img.rocket.new/generatedImages/rocket_gen_img_1b3465868-1772137524990.png", alt: 'Vintage pencil sketch portrait of golden retriever with ornate frame border', style: 'Pencil Sketch', date: 'Apr 12, 2026' },
{ id: 'port-004', src: "https://images.unsplash.com/photo-1501751349214-e73f5e3307bd", alt: 'Royal portrait of golden retriever in regal pose with crown and velvet background', style: 'Royal Portrait', date: 'Mar 3, 2026' }];


export default function DogPortraitGallery() {
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-700 text-foreground">Portrait Studio</h2>
        <span className="text-sm text-muted-foreground">4 portraits created</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {PORTRAITS?.map((p) =>
        <div key={p?.id} className="bg-card border border-border rounded-2xl overflow-hidden shadow-card card-hover group">
            <div className="relative h-56 bg-muted overflow-hidden">
              <AppImage src={p?.src} alt={p?.alt} fill className="object-cover group-hover:scale-105 transition-transform duration-500" sizes="(max-width: 768px) 100vw, 25vw" />
              <div className="absolute inset-0 bg-foreground/30 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-3">
                <button
                onClick={() => toast?.success('Downloading portrait...')}
                className="w-9 h-9 bg-white rounded-full flex items-center justify-center hover:bg-muted"
                title="Download portrait">
                
                  <Download size={15} className="text-foreground" />
                </button>
                <button
                onClick={() => toast?.success('Share link copied!')}
                className="w-9 h-9 bg-white rounded-full flex items-center justify-center hover:bg-muted"
                title="Share portrait">
                
                  <Share2 size={15} className="text-foreground" />
                </button>
              </div>
            </div>
            <div className="p-3">
              <p className="font-700 text-sm text-foreground">{p?.style}</p>
              <p className="text-xs text-muted-foreground">{p?.date}</p>
            </div>
          </div>
        )}
      </div>
    </div>);

}